import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/specPilot")({
  component: SpecPilotLayout,
});

function SpecPilotLayout() {
  return <Outlet />;
}
